import { render, staticRenderFns } from "./CertificadosSolicitudesFuncionarioView.vue?vue&type=template&id=620ee367&scoped=true&"
import script from "./CertificadosSolicitudesFuncionarioView.vue?vue&type=script&lang=js&"
export * from "./CertificadosSolicitudesFuncionarioView.vue?vue&type=script&lang=js&"
import style0 from "./CertificadosSolicitudesFuncionarioView.vue?vue&type=style&index=0&id=620ee367&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ee367",
  null
  
)

export default component.exports